<template>
  <v-card color="primary full-height">
    <v-img :src="fullUrl" contain />
    <v-card-actions v-if="store.getters.permissionToWrite">
      <v-spacer />
      <v-tooltip v-if="field.metadata" top>
        <template #activator="{ on }">
          <v-btn :disabled="refreshLoading || (!field.multivalued ? cloudinaryLoading : false)" fab x-small color="primary" v-on="on" @click="emit('get-cloudinary-resource');">
            <v-icon>refresh</v-icon>
          </v-btn>
        </template>
        <span>
          Forcer la remise en cache des métadonnées.
        </span>
      </v-tooltip>
      <v-btn v-if="!field.multivalued" :disabled="refreshLoading || (!field.multivalued ? cloudinaryLoading : false)" fab x-small color="primary" @click="emit('launch-cloudinary')">
        <v-icon>edit</v-icon>
      </v-btn>

      <v-btn :disabled="itemsLoading || (!field.multivalued ? cloudinaryLoading : false)" fab x-small color="primary" @click="emit('delete-resource')">
        <v-icon>delete</v-icon>
      </v-btn>
    </v-card-actions>
    <v-card-text v-if="field.caption || field.metadata">
      <SimpleField
        v-if="field.caption"
        v-model="value.caption"
        :field="{ label: 'Légende', type: 'String', viewType: 'text' }"
      />

      <section v-if="field.metadata">
        <v-row
          align="center"
          justify="start"
          no-gutters
          class="flex-nowrap"
        >
          <h3 class="mr-2 subtitle-1 font-weight-medium metadata-status" v-bind="!refreshLoading ? { 'style': `--status-color: ${getSeoStatus.color}` } : ''">Metadata</h3>
          <v-tooltip v-if="!refreshLoading && getSeoStatus.message" top>
            <template #activator="{ on }">
              <v-icon small v-on="on">mdi-information</v-icon>
            </template>
            <span>
              {{ getSeoStatus.message }}
            </span>
          </v-tooltip>
        </v-row>
        <v-row v-if="refreshLoading">
          <v-progress-circular class="loading" :width="3" :size="25" indeterminate color="info" />
        </v-row>
        <v-row v-if="value.metadata && !refreshLoading">
          <template v-for="(data, dataIndex) in value.metadata">
            <v-list-item
              v-if="data"
              :key="dataIndex"
              :class="[
                'px-0',
                { 'pt-1' : dataIndex != 0 }
              ]"
            >
              <div
                v-if="data"
                :key="dataIndex"
                class="px-0"
              >
                <h4 class="text-caption text-uppercase font-weight-light">{{ store.getters.getReference('cloudinary_labels')?.[dataIndex] }}</h4>
                <p class=" white--text mb-1 force-wrap">{{ data }}</p>
              </div>
            </v-list-item>
          </template>
        </v-row>
        <v-row v-else class="mt-1">
          <span v-if="!refreshLoading">No metadata!</span>
        </v-row>
      </section>
    </v-card-text>
  </v-card>
</template>

<script setup>
import { computed } from 'vue';
import { useStore } from 'vue2-helpers/vuex';

import SimpleField from '../SimpleField.vue';
import { getMediaUrl } from '../../../utils/content';

// eslint-disable-next-line no-undef
const emit = defineEmits(['input']);

// eslint-disable-next-line no-undef
const props = defineProps({
  value: { type: Object, default: null },
  refreshLoading: { type: Boolean, default: false },
  itemsLoading: { type: Boolean, default: false },
  cloudinaryLoading: { type: Boolean, default: false },
  field: { type: Object, default: () => {} }
});

const store = useStore();

const fullUrl = computed(() => getMediaUrl(props.value.url, 'w_150,h_100,c_fill'));

const getSeoStatus = computed(() => {
  if (!props.value.metadata || !Object.keys(props.value.metadata).length) return { color: '#ff5100', message: 'Aucune métadonnées définie!' };
  if (!props.value.metadata.alt) return { color: '#ffed00', message: 'Aucune Alt définie!' };
  return { color: '#00ff9d' };
});

</script>

<style lang="scss" scoped>
.force-wrap {
  word-break: break-all;
  white-space: normal;
}
.v-card__actions {
  position: absolute;
  right: 0;
  top: 0;
}
.list-reset {
  list-style: none;
}
.loading {
    margin: 12px;
}

.metadata-status:before {
  content: "•";
  color: var(--status-color, #fff);
  font-size: 35px;
  vertical-align: middle;
  margin-right: 4px;
}

.full-height {
  height: 100%;
}
</style>
